import { render, staticRenderFns } from "./VModalImportData.vue?vue&type=template&id=577f6a15&scoped=true&"
import script from "./VModalImportData.vue?vue&type=script&lang=ts&"
export * from "./VModalImportData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f6a15",
  null
  
)

export default component.exports